import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  // Variables to show & hide footer elements
  IWantTo = true;
  PassportAndCitizenship = true;
  Travel = true;
  WhatWeDo = true;
  NewsAndMedia = true;

  constructor() { }

  ngOnInit() {

    // Detect if the window is smaller then 768 in width, If so we want the footer 
    // Links to be collapsed on load
    if (window.innerWidth < 768) {
      this.IWantTo = !this.IWantTo;
      this.PassportAndCitizenship = !this.PassportAndCitizenship;
      this.Travel = !this.Travel;
      this.WhatWeDo = !this.WhatWeDo;
      this.NewsAndMedia = !this.NewsAndMedia;
    }
  }

  backToTop() {
    const scrollToTop = window.setInterval(() => {
      const pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 20);
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 10);
  }

  // Switch function to toggle footer bool vars 
  toggleDisplay(footer) {
    if (window.innerWidth < 768) {
      switch (footer) {
        case 'IWantTo':
          this.IWantTo = !this.IWantTo;
          break;
        case 'PassportAndCitizenship':
          this.PassportAndCitizenship = !this.PassportAndCitizenship;
          break;
        case 'Travel':
          this.Travel = !this.Travel;
          break;
        case 'WhatWeDo':
          this.WhatWeDo = !this.WhatWeDo;
          break;
        case 'NewsAndMedia':
          this.NewsAndMedia = !this.NewsAndMedia;
          break;
      }
    }
  }

}
